import {
  Stack,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { FC } from 'react';
import ja from 'utils/ja';

interface TableProps {
  headers: {
    key: string;
    title: string;
    align?: 'center' | 'left' | 'right' | 'justify' | 'inherit';
  }[];
  data: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }[];
}

const Table: FC<TableProps> = ({ headers, data }) => {
  return (
    <TableContainer>
      <MuiTable
        sx={{
          '& .MuiTableCell-root.MuiTableCell-head': {
            border: 'none',
          },
        }}
      >
        <TableHead
          sx={{
            '& *': {
              fontWeight: '700 !important',
            },
            backgroundColor: 'transparent',
          }}
        >
          <TableRow>
            {headers.map((header) => (
              <TableCell
                key={`header-${header.key}`}
                sx={{ paddingBottom: '26px' }}
                align={header.align}
              >
                <Typography component='span' sx={{ whiteSpace: 'nowrap' }}>
                  {header.title}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {!data.length ? (
            <Stack
              height='70%'
              width='100%'
              justifyContent='center'
              alignItems='center'
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Typography
                component='p'
                textAlign='center'
                sx={{ fontSize: '26px !important', width: '80%' }}
              >
                {ja.message_error.no_data}
              </Typography>
            </Stack>
          ) : (
            data.map((row, index) => (
              <TableRow
                key={`row-${row.idNumber}-${index}`}
                sx={{
                  '& tr.MuiTableRow-root': {
                    overflow: 'hidden',
                  },
                  backgroundColor: '#fff',
                  '& .MuiTableCell-root:first-child': {
                    borderBottomLeftRadius: '10px',
                  },
                  '& .MuiTableCell-root:last-child': {
                    borderBottomRightRadius: '10px',
                  },
                }}
              >
                {headers.map(({ key, align }) => (
                  <TableCell key={`row-${index}-${key}`} align={align}>
                    {row[key]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default Table;
